import theme from '../base'

const dialog = {
  MuiDialog: {
    defaultProps: {
      maxWidth: false,
      PaperProps: {
        elevation: 2,
      },
    },
    styleOverrides: {
      paper: {
        borderRadius: theme.spacing(1),
      },
      paperWidthFalse: {
        maxWidth: 560,
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: theme.spacing(5),
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: theme.spacing(4, 0, 0),
        whiteSpace: 'nowrap',
        '& > :not(:first-of-type)': {
          marginLeft: theme.spacing(2),
        },
      },
    },
  },
}

export default dialog
